import { render, staticRenderFns } from "./AppRelatedSmallSectionItem.vue?vue&type=template&id=40dea9ee&"
import script from "./AppRelatedSmallSectionItem.vue?vue&type=script&lang=js&"
export * from "./AppRelatedSmallSectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports